@if (isDataLoaded) {
<div class="profile-block">
  @if (!isShowAvatar) {
  <div class="avatar-gray" (click)="profileLogout()"></div>
  }
  @else {
  @if (avatarUrl) {
  <div class="avatar" [style]="{'background-image': 'url(' + avatarUrl + ')'}" (click)="profileLogout()"></div>
  }
  @else {
  <div class="avatar-default" (click)="profileLogout()"></div>
  }
  }
  <div class="profile-name">{{accountInfo.accountName}}</div>
  <div class="profile-mail">{{accountInfo.accountEmail}}</div>
  <div class="profile-mail">Ваш account ID {{accountInfo.id}}</div>
</div>
}
@if (!isDataLoaded) {
<div class="profile-block">
  <div class="wait"></div>
</div>
}
